<template>
    <main class="CercaView-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <h3>Promociones cerca de ti</h3>
        <img src="../assets/promociones-cerca-de-ti.png"/>

        <h2>Encuentra las mejores ofertas más cerca de ti</h2>
        <br/>
        <img src="../assets/encuentra-donde-puedes.png" class="encuentra-donde-puedes"/>

        <!--<img src="../assets/examples/map-example.png"/>-->

        <section class="map-wrapper">
            <p v-if="loadingCupones">Cargando cupones...</p>
            <div class="map-cupones" v-if="!loadingCupones">
                <a v-for="(item, index) in coincidences.slice(0, 3)" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}">
                </a>
            </div>
            <ViewMapByCoordinates
                v-if="!loading"
                :items="cupones"
                :api-key="apiKey"
                :radius="10_000"
            />
        </section>

        <br/>
        <br/>

    </main>
    </main>
</template>

<script>
import ViewMapByCoordinates from './ViewMapByCoordinates.vue';

export default {
    name: 'CercaView',
    components: { ViewMapByCoordinates },
    data(){
        return{
            apiKey: "AIzaSyBWYjaZoteGTAD_Ujgi1BK1T9A3DmXqGk4",
            cupones: [],
            namedCupones: [],
            coincidences: [],
            loading: true,
            loadingCupones: true,
        }
    },
    methods: {
        async getCupones(){
            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: '1',
                    tipo_cupon: '1',
                })
            });
            const result = await response.json();

            this.cupones = (result.data || []).filter(c => {
                return c.coordenadas && c.coordenadas.includes(",");
            });

            this.coincidences = this.cupones.slice(0, 3);

            this.loading = false;
            this.loadingCupones = false;
        },

        getFrontURL(){
			return window.location.origin;
		},
    },
    mounted(){
        this.getCupones();
    }
}
</script>

<style scoped lang="stylus">
.CercaView-MAIN{
    font-family: 'Benton Sans BBVA book';
    background-color: #9e97f863;
    min-height: calc(100vh - 40px);
}

.INNER-MARGIN{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.INNER-MARGIN > img:not(.encuentra-donde-puedes){
    width: 100%;
    margin-bottom: 1ch;
}

h3, section > p, .INNER-MARGIN > p{
    width: 100%;
    text-align: center;
}

h3{
    font-weight: 200;
    color: white;
    background-color: #051283;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1ch;
}

h2{
    font-family: 'Benton Sans BBVA bold';
    color: #051283;
    margin-bottom: 0.3ch;
}

.encuentra-donde-puedes{
    width: auto;
    height: 3.1ch;
    margin-bottom: 3.5ch;
}

.map-wrapper
    display: flex
    align-items: center
    width: 100%
    height: 300px

    >p
        width: fit-content
        padding: 0 1ch
        white-space: nowrap

    >.map-cupones
        display: flex
        flex-direction: column
        padding: 10px

        img
            height: 90px

/* RESPONSIVE */
@media all and (max-width:780px)

    .CercaView-MAIN
        min-height: calc(100vh - 40px + 300px)

    h2
    h3
    p
        text-align: center

    .map-wrapper
        flex-direction: column
        
        >.map-cupones
            align-items: center
            justify-content: center
            width: 100%

            >a
                display: flex
                align-items: center
                justify-content: center
                margin-bottom: 10px

            img
                width: 80%
                height: auto


</style>